export const AUTH_URL = `${process.env.CALENDAR_APP_URL}:8443/api`;
// export const AUTH_URL = 'http://localhost:8084/api';
// export const AUTH_URL = 'http://109.195.55.33:8084/api';
// export const AUTH_URL = 'http://172.22.4.178:8080/api';
// export const AUTH_URL = 'https://calendar.relex.ru:8443/api'; // Прод-стенд